/*
 * Authors: mariushirjanu, Koen, Triadi
 * Created: 30/10/2015
 * Upgraded: 20/03/2023
 */
import { ChangeDetectorRef, Component } from '@angular/core';
import { GaFormlyService } from '@app/shared/formly/ga-formly.service';
import { OrderEntryLocationDataService } from '../order-entry-location-data.service';
import { OrderEntryLocationFormService } from '../order-entry-location-form.service';
import { BaseLocationAddressComponent, LOCATION_ADDRESS_TEMPLATE } from './base-location-address.component';
import { CountryDataService } from '@app/shared/location/country-data.service';
import { OrderEntryWebshopService } from '../../webshop/order-entry-webshop.service';
import { OrderEntryLocationService } from '../order-entry-location.service';
import { GaValidateService } from '@app/shared/formly/ga-validate.service';
import { GaDeferredService } from '@app/shared/services/ga-deferred.service';

@Component({
  selector: 'order-location-address-current',
  template: LOCATION_ADDRESS_TEMPLATE
})
export class OrderLocationAddressCurrentComponent extends BaseLocationAddressComponent {
  constructor(
    countryDataService:CountryDataService,
    formlyService:GaFormlyService,
    orderEntryLocationService:OrderEntryLocationService,
    orderEntryLocationDataService:OrderEntryLocationDataService,
    orderEntryLocationFormService:OrderEntryLocationFormService,
    orderEntryWebshopService:OrderEntryWebshopService,
    validateService:GaValidateService,
    deferredService:GaDeferredService,
    changeDetectorRef:ChangeDetectorRef
  ) {
    super(
      countryDataService,
      formlyService,
      orderEntryLocationService,
      orderEntryLocationDataService,
      orderEntryLocationFormService,
      orderEntryWebshopService,
      validateService,
      changeDetectorRef,
      deferredService
    );
  }
}